<script>
export default {
  name: 'OrderNavigation'
}
</script>

<script setup>
import { url } from '@/config/urls';
import router from '@/router/index.js';
import { useAuthStore } from '@stores/auth.js';

const auth = useAuthStore();
// コンポーネントに渡されたpropsの取得
const props = defineProps({
  /**
   * 画面ID
   *    [発注TOP] OrderSearch
   *    [発注履歴] OrderHistory
   *    [お気に入り一覧] OrderFavorite
   *    [お気に入り詳細] OrderFavoriteDetail
   *    [カート] OrderCart
   */
  screenId: {
    type: String,
    required: true
  },
  isPermittedOrder: {
    type: Boolean,
    required: false,
    default: false
  },
  // カート商品 品目数
  cartGoodsTotalRecord: {
    type: Number,
    required: true
  },
  orderSearchPageUrl: {
    type: String,
    default: url.page.orderSearch
  },
  orderHistoryPageUrl: {
    type: String,
    default: url.page.orderHistory
  },
  orderFavoritePageUrl: {
    type: String,
    default: url.page.orderFavorite
  },
  orderCartPageUrl: {
    type: String,
    default: url.page.orderCart
  },
  orderCartCountApiUrl: {
    type: String,
    default: url.api.orderCart.count
  }
});

</script>

<template>
  <div class="com_inner2 clearfix">
    <ul v-if="props.screenId === 'OrderSearch' && !props.isPermittedOrder" class="com_links1">
      <li><router-link :to="props.orderSearchPageUrl" class="current">在庫問合せTOP</router-link></li>
    </ul>
    <ul v-else class="com_links1">
      <li><router-link :to="props.orderSearchPageUrl" :class="{ current: props.screenId === 'OrderSearch' }">発注TOP</router-link></li>
      <li><router-link :to="props.orderFavoritePageUrl" :class="{ current: props.screenId === 'OrderFavorite' || props.screenId === 'OrderFavoriteDetail' }">お気に入り</router-link></li>
      <li><router-link :to="props.orderHistoryPageUrl" :class="{ current: props.screenId === 'OrderHistory' }">発注履歴</router-link></li>
      <li><router-link :to="props.orderCartPageUrl" :class="{ current: props.screenId === 'OrderCart' }">カート
        <img :src="props.screenId === 'OrderCart' ? '/front/assets/common/img/icon_cart2.png' : '/front/assets/common/img/icon_cart1.png'" alt="" class="com_icon_cart1">
        <span v-if="props.cartGoodsTotalRecord != null && props.cartGoodsTotalRecord > 0" class="com_cart_num1">{{ props.cartGoodsTotalRecord }}</span>
      </router-link></li>
    </ul>
  </div>
</template>
